<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>시스템 관리</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">시스템 관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">메뉴관리</p>
          <ul class="depth">
            <li><router-link to="/usermanagement" title="사용자관리">사용자관리</router-link></li>
            <li><router-link to="/teamlist" title="팀관리">팀관리</router-link></li>
            <li><router-link to="/departmentlist" title="부서관리">부서관리</router-link></li>
            <li><router-link to="/menulist" title="메뉴관리">메뉴관리</router-link></li>
            <li><router-link to="/userauthoritylist" title="사용자권한관리">사용자권한관리</router-link></li>
            <li><router-link to="/accessinfo" title="접속정보">접속정보</router-link></li>
            <!-- <li><router-link to="/connertmenustat" title="메뉴접속통계">메뉴접속통계</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">메뉴관리</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ listData.length }}</span
              >건
            </div>
            <div class="searchBox">
              <div>
                <search-box @emitSearch="searchBtn" @emitPerChange="changePerPage">
                  <template slot="searchCondition">
                    <option value="1">메뉴ID</option>
                    <option value="2">한글메뉴명</option>
                    <option value="3">메뉴설명</option>
                  </template>
                </search-box>
              </div>
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  메뉴관리 테이블
                </caption>
                <colgroup>
                  <col style="width: 10%" />
                  <col style="width: 10%" />
                  <col style="width: auto" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                  <!-- <col style="width: 15%" /> -->
                </colgroup>
                <thead>
                  <tr>
                    <!-- <th scope="col">
                      <p class="checkbox">
                        <input type="checkbox" id="allCheck" class="hidden" v-model="allChecked" @click="checkedAll" />
                        <label for="allCheck"></label>
                      </p>
                    </th> -->
                    <th scope="col">번호</th>
                    <th scope="col">메뉴ID</th>
                    <th scope="col">한글 메뉴명</th>
                    <th scope="col">프로그램파일명</th>
                    <th scope="col">메뉴설명</th>
                    <th scope="col">상위메뉴ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="5">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index" @click="view(item)">
                    <!-- <td @change="checkboxCkc()">
                      <p class="checkbox">
                        <input
                          type="checkbox"
                          :id="'itemCheck_' + item.menuNo"
                          v-model="checkedValues"
                          :value="item.upperMenuId + ';' + item.menuNo + ';' + item.progrmFileNm + ';' + item.menuDc"
                        />
                        <label :for="'itemCheck_' + item.menuNo"></label>
                      </p>
                    </td> -->
                    <td>{{ startOffset + index + 1 }}</td>
                    <td>{{ item.menuNo }}</td>
                    <td>{{ item.menuNm }}</td>
                    <td>{{ item.progrmFileNm }}</td>
                    <td>{{ item.menuDc }}</td>
                    <td>{{ item.upperMenuId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--btnArea-->
          <div class="btnArea txt-right">
            <!-- <button type="button" class="btn border">선택삭제</button>
                        <button type="button" class="btn border" @click="$router.push('menuenrollment')">등록</button> -->
          </div>

          <!-- 페이지네이션 -->
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';
import SearchBox from '../../../components/SearchBox.vue';

export default {
  data() {
    return {
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      searchCondition: '',
      searchKeyword: '',
      nodata: true,
      checkedValues: [],
      allChecked: false,
    };
  },

  mounted() {
    this.searchBtn();
  },

  components: {
    SearchBox,
  },

  methods: {
    async searchBtn(searchCondition, searchKeyword) {
      await axios
        .get('/api/menu/menuListSelect.json', {
          params: {
            searchCondition: searchCondition,
            searchKeyword: searchKeyword,
          },
        })
        .then(response => {
          var data = response.data;
          if (data.list_menulist && data.list_menulist.length > 0) {
            this.listData = data.list_menulist;
            this.nodata = false;
          } else {
            this.listData = [];
            this.nodata = true;
          }

          this.curPageNum = 1;
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    view(item) {
      this.$router.push({
        path: 'menuview',
        query: { item: item },
      });
    },

    changePerPage(dataPerPage) {
      this.dataPerPage = dataPerPage;
      this.curPageNum = 1;
    },

    checkboxCkc() {
      if (this.calData.length === this.checkedValues.length) {
        this.allChecked = true;
        return;
      }
      this.allChecked = false;
    },

    checkedAll() {
      if (!this.allChecked) {
        this.checkedValues = [];

        this.calData.forEach(element => {
          this.checkedValues.push(
            element.upperMenuId + ';' + element.menuNo + ';' + element.progrmFileNm + ';' + element.menuDc,
          );
        });
      } else {
        this.checkedValues = [];
      }
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length) {
        return this.listData.slice(this.startOffset, this.endOffset);
      }
    },
  },
};
</script>
